import AppPanel from '../fw/AppPanel.react';
import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import DetailBox from '../fw/DetailBox.react.js';

import urlMapping from '../app/URLMapping';
import types from '../../common/model-api/types';

import {wrapNotFound} from '../app/NotFoundHandler.react';

import TableDetail from '../fw/TableDetail.react';
import { User } from '../../common/types/types';

interface RunningJobViewProps {
 relay: object;
 user: User;
}

class RunningJobView extends React.Component<RunningJobViewProps> {

    typeName = 'runningJobs';

    static propTypes = {
        relay: PropTypes.object.isRequired,
        user: PropTypes.object.isRequired
    };

    constructor() {
        super();

        this.state = {};
    }

    render() {
        const data = this.props.user.myInstance;
        let type = types[this.typeName];

        return (
            <AppPanel breadcrumbParams={[
                {type, data},
            ]}  title={data.name}>
                    <DetailBox data={data} metadata={type} urlMapping={urlMapping}>

                        <TableDetail columns={['organisation.name', 'flow.flowDef.name', 'flow.name', 'flowStepDef.name', 'createdAt', 'keepAlive', 'expiresIn']} data={data} metadata={type} />
                    </DetailBox>

            </AppPanel>
        );
    }
}

export default Relay.createContainer(wrapNotFound(RunningJobView, (props) => {
    return props.user.myInstance && props.user.myInstance.runningJob;
}), {
    initialVariables: {
        instanceId: '',
        runningJobId: '',
    },
    prepareVariables (variables) {
        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                myInstance(id: $instanceId) {
                    id,
                    realId,
                    name,
                    runningJob(id: $runningJobId) {
                        id,
                        realId,
                        createdAt,
                        keepAlive,
                        expiresIn,
                        flow {
                            id,
                            realId,
                            name,
                            flowDef {
                                id,
                                realId,
                                name,
                            }
                        },
                        organisation {
                            id,
                            realId,
                            name,
                        },
                        flowStepDef {
                            id,
                            realId,
                            name,
                        }
                    }
                }
            }
        `,
    },
});
